<template lang="pug">
  b-container(style="padding-bottom:70px;")
    b-button.mb-4(variant="light", @click="$router.push({name: 'Products Categories' })")
      .d-flex.align-items-center
        arrow-left-icon.icon-md.mr-2
        span Volver a categorías

    .text-right.mb-3
      b-button(variant="primary" @click="createCategory()") Crear subcategoría
    b-card.bg-light(v-if="Category.category_id" no-body)
      .bg-white(style="border-radius:5px;")
        .p-3.category-row
          input(type="file" accept="image/*" :ref="Category.category_id" hidden @change="imagePicked($event, Category)")
          b-row
            b-col(md="auto")
              b-img.pointer(:src="Category.image" :blank="!Category.image" blank-color="#f2f2f2" rounded width="150" height="150" style="object-fit:scale-down;border:1px solid #f2f2f2;" center @click="$refs[Category.category_id].click()")
              .text-center
                b-button.text-danger.text-sm(variant="link" v-if="Category.image" @click="Category.image = '';updateCategory(Category);") Quitar imagen
                b-button.text-primary.text-sm(variant="link" v-else @click="$refs[Category.category_id].click()") Subir imagen
            b-col
              b-form-row
                b-col.mb-lg-0.mb-3(lg="4")
                  b-form-group(label="Nombre de la categoría")
                    b-form-input(placeholder="Nombre de la categoría" v-model="Category.name" @input="updateCategory(Category, 700)")
                b-col(lg="8")
                  b-form-group(label="Descripción")
                    b-form-input(placeholder="Descripción" v-model="Category.description" @input="updateCategory(Category, 700)")
                b-col.mt-3
                  .text-right
                    b-button.text-danger.text-sm(variant="link" @click="confirmDeleteCategory(Category)") Eliminar categoría
        .p-3.category-row.children(v-for="child in Category.Children")
          corner-down-right-icon.children-arrow-pointer.text-secondary
          b-col.w-100.d-flex.flex-row-reverse(cols="auto" md="auto")
            b-button(size="sm"  variant="primary" @click="createCategory(child.category_id)") Crear subcategoría
          input(type="file" accept="image/*" :ref="child.category_id" hidden @change="imagePicked($event, child)")
          b-row
            b-col(md="auto")
              b-img.pointer(:src="child.image" :blank="!child.image" blank-color="#f2f2f2" rounded width="100" height="100" style="object-fit:scale-down;border:1px solid #f2f2f2;" center @click="$refs[child.category_id][0].click()")
              .text-center
                b-button.text-danger.text-sm(variant="link" v-if="child.image" @click="child.image = '';updateCategory(child);") Quitar imagen
                b-button.text-primary.text-sm(variant="link" v-else @click="$refs[child.category_id][0].click()") Subir imagen
            b-col
              b-form-row
                b-col.mb-lg-0.mb-3(lg="4")
                  b-form-group
                    p.text-secondary Nombre de subcategoría
                    b-form-input(placeholder="Nombre de subcategoría" v-model="child.name" @input="updateCategory(child, 700)")
                b-col(lg="8")
                  b-form-group
                    p.text-secondary Descripción
                    b-form-input(placeholder="Descripción" v-model="child.description" @input="updateCategory(child, 700)")
                b-col.mt-3
                  .text-right
                    b-button.text-danger.text-sm(variant="link" @click="confirmDeleteCategory(child, true)") Eliminar subcategoría
          .p-3.category-row.children(v-for="child in child.Children")
            corner-down-right-icon.children-arrow-pointer.text-secondary
            input(type="file" accept="image/*" :ref="child.category_id" hidden @change="imagePicked($event, child)")
            b-row
              b-col(md="auto")
                b-img.pointer(:src="child.image" :blank="!child.image" blank-color="#f2f2f2" rounded width="100" height="100" style="object-fit:scale-down;border:1px solid #f2f2f2;" center @click="$refs[child.category_id][0].click()")
                .text-center
                  b-button.text-danger.text-sm(variant="link" v-if="child.image" @click="child.image = '';updateCategory(child);") Quitar imagen
                  b-button.text-primary.text-sm(variant="link" v-else @click="$refs[child.category_id][0].click()") Subir imagen
              b-col
                b-form-row
                  b-col.mb-lg-0.mb-3(lg="4")
                    b-form-group
                      p.text-secondary Nombre de subcategoría
                      b-form-input(placeholder="Nombre de subcategoría" v-model="child.name" @input="updateCategory(child, 700)")
                  b-col(lg="8")
                    b-form-group
                      p.text-secondary Descripción
                      b-form-input(placeholder="Descripción" v-model="child.description" @input="updateCategory(child, 700)")
                  b-col.mt-3
                    .text-right
                      b-button.text-danger.text-sm(variant="link" @click="confirmDeleteCategory(child, true)") Eliminar subcategoría
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex'
const categoryController = createNamespacedHelpers('category')
import { toBase64 } from '@/helpers/file-converter'
import { UploadFile } from '@/helpers/upload-file'

export default {
  data () {
    return {
      Category: {},
      timeout: null
    }
  },
  methods: {
    ...mapActions(['category/get', 'category/create', 'category/update', 'category/destroy', 'helpers/upload_file']),
    getCategory () {
      this['category/get']({
        account_id: this.$route.params.account_id,
        category_id: this.$route.params.category_id,
        callback: res => {
          if (res.error) {
            this.$message.error(res.error)
          } else {
            console.log(res)
            this.Category = res.resource
          }
        }
      })
    },
    async createCategory (parent) {
      this['category/create']({
        account_id: this.$route.params.account_id,
        parent_category_id: parent || this.$route.params.category_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            this.$message.success('Subcategoría creada y agregada a la lista')
            this.getCategory()
          }
        }
      })
    },
    async updateCategory (category, debounce) {
      clearTimeout(this.timeout)
      this.loading = true

      this.timeout = setTimeout(() => {
        this['category/update']({
          account_id: this.$route.params.account_id,
          ...category,
          callback: res => {
            globalThis.loading = false
            if (res.error) {
              this.$message.error(res.error)
            } else {
              this.$message.success('Categoría actualizada con éxito')
            }
          }
        })
      }, debounce || 0)
    },
    confirmDeleteCategory (category, isSub) {
      let self = this

      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la ${isSub ? 'sub' : ''}categoría \"${category.name}\"? No se puede deshacer.`, {
          title: 'Eliminar',
          okTitle: 'Eliminar',
          okVariant: 'danger',
          cancelTitle: 'Cancelar'
        })
        .then(value => {
          if (value == true) {
            self.deleteCategory(category, isSub)
          }
        })
        .catch(err => {
          // An error occurred
        })
    },
    deleteCategory (category, isSub) {
      let self = this

      this['category/destroy']({
        account_id: self.$route.params.account_id,
        ...category,
        callback: res => {
          if (res.error) return self.$message.error(res.error)
          self.$message.success('Categoría eliminada')
          if (isSub) {
            const {parent_category_id} = category
            const parent = this.Category.Children.find(c => c.category_id === parent_category_id)
            if(parent) {
              const index = parent.Children.findIndex(c => c.category_id === category.category_id)
              return parent.Children.splice(index, 1)
            }
            this.Category.Children.splice(this.Category.Children.findIndex(c => c.category_id === category.category_id), 1)
          } else {
            this.$router.push({ name: 'Products Categories' }).catch(()=>{});
          }
        }
      })
    },
    async imagePicked (event, category) {
      let file = event.target.files[0]

      if (file) {
        this.showLoadingScreen()
        try {
          let image_file = await UploadFile.call(this, file)
          category.image = image_file
          event.target.value = null
          this.updateCategory(category)
        } catch (e) {
          category.image = ''
          self.$message.error('Error subiendo imagen')
        }

        this.hideLoadingScreen()
      }
    },
    async uploadFile (file) {
      let self = this
      return new Promise (async (resolve, reject) => {
        let params = {
          file_name: file.name,
          mime: file.type
        }

        try {
          if (file.name.includes('.'))
            params.file_extension = file.name.split('.').slice(-1)
        } catch (e) {
          console.log(e.message)
        }

        try {
          let fileBase64 = await toBase64(file, true)
          params.file = fileBase64
        } catch (e) {
          console.log(e.message)
          reject(new Error('Error cargando archivo'))
        }

        self['helpers/upload_file']({
          ...params,
          callback: res => {
            if (res.error) {
              reject(new Error(res.error))
            } else {
              resolve(res.resource.url)
            }
          }
        })
      })
    },
  },
  mounted () {
    this.getCategory()
  }
}
</script>

<style lang="scss" scoped>
  .category-row {
    &:not(:last-child) {
      border-bottom: 1px solid #f2f2f2;
    }

    &.children {
      padding-left: 5rem !important;
      position: relative;

      .children-arrow-pointer {
        position: absolute;
        top: 15px;
        left: 30px;
      }
    }
  }
</style>